import { render, staticRenderFns } from "./FormAuth.vue?vue&type=template&id=383631dd&scoped=true&lang=pug&"
import script from "./FormAuth.vue?vue&type=script&lang=js&"
export * from "./FormAuth.vue?vue&type=script&lang=js&"
import style0 from "./FormAuth.vue?vue&type=style&index=0&id=383631dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383631dd",
  null
  
)

export default component.exports